/**
 * Máscaras e validações das telas de faturas, no lugar do jquery.mask e do
 * jquery.maskMoney das telas antigas (mesmos formatos).
 */
/** Aplica um padrão em que "#" e "0" são dígitos (como o jquery.mask). */
function applyPattern(value, pattern) {
    const digits = value.replace(/\D/g, '');
    let out = '';
    let i = 0;
    for (const ch of pattern) {
        if (i >= digits.length)
            break;
        if (ch === '#' || ch === '0') {
            out += digits[i++];
        }
        else {
            out += ch;
        }
    }
    return out;
}
/** CPF: 000.000.000-00 */
export function maskCpf(value) {
    return applyPattern(value, '000.000.000-00');
}
/** CEP: #####-### */
export function maskCep(value) {
    return applyPattern(value, '#####-###');
}
/** Igual ao formatString das views antigas (preenche "#" com os caracteres na ordem). */
export function formatString(value, pattern) {
    let i = 0;
    const v = value.toString();
    return pattern.replace(/#/g, () => { var _a; return (_a = v[i++]) !== null && _a !== void 0 ? _a : ''; });
}
/**
 * Valor em reais como o jquery.maskMoney({decimal: ",", thousands: ".", allowZero: true}):
 * os dígitos entram pela direita, sempre com 2 casas.
 */
export function maskMoney(value) {
    const digits = value.replace(/\D/g, '').replace(/^0+(?=\d)/, '');
    if (digits === '')
        return '';
    const padded = digits.padStart(3, '0');
    const int = padded.slice(0, -2).replace(/^0+(?=\d)/, '');
    const dec = padded.slice(-2);
    return `${int.replace(/\B(?=(\d{3})+(?!\d))/g, '.')},${dec}`;
}
/** Mesma validação de CPF das views antigas (validaCPF). */
export function validaCPF(cpf) {
    const str = String(cpf).replace(/[^\d]/g, '');
    if (str.length !== 11)
        return false;
    if (/^(\d)\1{10}$/.test(str))
        return false;
    let soma = 0;
    for (let i = 1; i <= 9; i++)
        soma += parseInt(str.substring(i - 1, i), 10) * (11 - i);
    let resto = (soma * 10) % 11;
    if (resto === 10 || resto === 11)
        resto = 0;
    if (resto !== parseInt(str.substring(9, 10), 10))
        return false;
    soma = 0;
    for (let i = 1; i <= 10; i++)
        soma += parseInt(str.substring(i - 1, i), 10) * (12 - i);
    resto = (soma * 10) % 11;
    if (resto === 10 || resto === 11)
        resto = 0;
    return resto === parseInt(str.substring(10, 11), 10);
}
